// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","title":"Footer_title__Q8g5X","information":"Footer_information__wf79M","copyright":"Footer_copyright__JQMtz"};